import { createFileRoute } from '@tanstack/react-router'
import { ROUTES } from '@/constants/routeConstants'
import { CookiePreferencesPage } from '@/pages/CookiePreferencesPage'

const CookiePreferencesRoute = () => {
  return <CookiePreferencesPage />
}

export const Route = createFileRoute(ROUTES.COOKIE_PREFERENCES)({
  component: CookiePreferencesRoute,
})
